import { Link, useLocation } from "react-router-dom";
import SiteLayout from "@/components/feature/SiteLayout";

export default function NotFound() {
  const location = useLocation();

  return (
    <SiteLayout>
      <section className="bg-background-50">
        <div className="mx-auto flex w-full max-w-3xl flex-col items-center px-4 py-20 text-center md:px-8 md:py-28">
          <p className="font-heading text-6xl font-black text-primary-200 md:text-8xl">404</p>
          <h1 className="mt-4 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            这一页还没被归档
          </h1>
          <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">
            你访问的地址
            <span className="mx-1 rounded bg-background-200 px-1.5 py-0.5 font-mono text-xs text-foreground-700">
              {location.pathname}
            </span>
            暂时没有对应的内容。可以回到首页，或直接进入往期存档继续浏览。
          </p>
          <div className="mt-7 flex flex-wrap justify-center gap-3">
            <Link
              to="/"
              className="whitespace-nowrap rounded-full bg-primary-500 px-6 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              回到首页
            </Link>
            <Link
              to="/archive"
              className="whitespace-nowrap rounded-full border border-background-300 px-6 py-2.5 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-600"
            >
              浏览往期存档
            </Link>
          </div>
        </div>
      </section>
    </SiteLayout>
  );
}